import React from 'react';
import { createPortal } from 'react-dom';
import { MomentFormModal } from './MomentFormModal';
import { MomentDetailModal } from './MomentDetailModal';
import { DeleteMomentModal } from './DeleteMomentModal';

// The form, detail and delete dialogs, driven by useMomentEditor.
// Rendered in a portal so they sit above any parent dialog.
export const MomentModals = ({ editor, moments, defaultPeople }) => {
  const { formState, setFormState, viewing, setViewing, toDelete, setToDelete, progress, handleSave, handleDelete } = editor;

  return createPortal(
    <>
      {formState && (
        <MomentFormModal
          moment={formState.moment}
          defaultPeople={defaultPeople}
          progress={progress}
          onSave={handleSave}
          onClose={() => setFormState(null)}
        />
      )}
      {viewing && !formState && !toDelete && (
        <MomentDetailModal
          moment={moments.find((m) => m.id === viewing.id) || viewing}
          onClose={() => setViewing(null)}
          onEdit={(moment) => { setViewing(null); setFormState({ moment }); }}
          onDelete={setToDelete}
        />
      )}
      {toDelete && (
        <DeleteMomentModal moment={toDelete} onConfirm={handleDelete} onClose={() => setToDelete(null)} />
      )}
    </>,
    document.body
  );
};